export type SignatureV2EntryWindow = {
  opener: unknown;
  location: { replace: (url: string) => void };
  close: () => void;
};

type SignatureV2WindowOpener = (url: string, target: string) => SignatureV2EntryWindow | null;

export const reserveSignatureV2EntryWindow = (openWindow: SignatureV2WindowOpener): SignatureV2EntryWindow | null => {
  const entryWindow = openWindow('', '_blank');
  if (entryWindow) entryWindow.opener = null;
  return entryWindow;
};
